import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { ManageDashboardViewRPC } from "./manageDashboardViewRPC";

export class ManageDashboardViewRPCClientImpl extends ManageDashboardViewRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: ManageDashboardViewRPC.Request): Promise<LeoRPCResult<ManageDashboardViewRPC.Response, ManageDashboardViewRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey-dashboard/ManageDashboardView",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      ManageDashboardViewRPC.ResponseDTO,
      ManageDashboardViewRPC.Errors.ErrorsDTO,
      ManageDashboardViewRPC.Response,
      ManageDashboardViewRPC.Errors.Errors
    >(
      response,
      "survey-dashboard/ManageDashboardView",
      ManageDashboardViewRPC.Response.fromDTO,
      ManageDashboardViewRPC.Errors.fromDTO
    );
  }
}
